 // @ts-nocheck
import './DevicePlaylistGroup.scss';
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import {arrayMoveImmutable} from 'array-move';
import { playlistStore, generalStore, deviceStore } from '../../store';
import { RESPONSE, ROUTES } from '../../js/_constants';
import Server from '../../js/config/_server';
import { apiPatch, apiGet } from '../../js/api';
import { useTranslation } from 'react-i18next';
import DeleteConfirmationModal from '../deleteConfirmationModal/DeleteConfirmationModal';
import helpers from '../../js/helpers';
import ItemCard from '../ItemCard/ItemCard';
import Loader from '../loader/Loader';
import { type PlaylistGroup } from '../../api/types/index';
import { findIndex, insert, isEmpty, propEq } from 'ramda';
import { type ActionButtonType } from '../ItemCard/ItemCard';

const NoPlaylistsText = () => {
    const { t } = useTranslation();
    return <p className="no-playlists">{t('device_detail_no_playlist_group')}</p>;
};

type PlaylistGroupCardProps = {
    name?: string;
    className?: string;
    playlistGroup: PlaylistGroup;
    buttons: Array<ActionButtonType | Element | React.ReactNode>;
    rest?: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    >;
};

export const PlaylistGroupCard: React.FC<PlaylistGroupCardProps> = ({
    className,
    playlistGroup,
    buttons,
    name,
    ...rest
}) => {
    const { t } = useTranslation();
    return (
        <>
            <ItemCard
                className={cx('b-device-playlists__playlist-card', className)}
                key={playlistGroup.uuid + className}
                name={name}
                href={`${ROUTES.PLAYLISTS}/groups/${playlistGroup.uuid}`}
                icon="media-playlist"
                title={playlistGroup.title}
                description={playlistGroup.description}
                footer={`${t('playlist_last_edit')} : ${
                    playlistGroup.updatedAt
                        ? helpers.humanDate(playlistGroup.updatedAt)
                        : ''
                }`}
                buttons={buttons}
                {...rest}
            />
        </>
    );
};

type DevicePlaylistsProps = {
    items: Playlist[];
    iri: string;
    isRecentPlaylists?: boolean;
};

const DevicePlaylistGroup = ({
    items,
    iri,
    isRecentPlaylists
}: DevicePlaylistsProps) => {
    const { t } = useTranslation();
    const { setPlaylistGroupId, playlistGroupId } = playlistStore();
    const { setModalOpen , isModalOpen} = generalStore();
    const {devices} = deviceStore();
    const [playlistGroups, setPlaylistGroups] = useState<Playlist[]>([]);

    useEffect(() => {
        setPlaylistGroups(items);
    }, [items]);

    const onCancelDeletion = () => {
        setModalOpen(false);
        setIsGroupDeletion(false);
    };

    const playlistIsAlreadyAssigned = (playlistId: string) =>
        findIndex(propEq(playlistId, '@id'), assignedPlaylists) > -1;

    const [isDeleting, setIsDeleting] = useState(false);

    const [isGroupDeletion, setIsGroupDeletion] = useState(false);

    const deletePlaylistGroup = async playlistId => {
        setIsDeleting(true);

        const assignedPlaylistGroup = await apiGet(`${Server.baseUrl}${playlistId}`);

        const devicesToSet = assignedPlaylistGroup.devices.filter(device => device !== iri);

        const newList = playlistGroups.filter(
            item => item[RESPONSE.ID] !== playlistId
        );

        const options = {
            body: {
                devices: devicesToSet.map(device => device['@id'])
            }
        };

        const url = `${Server.baseUrl}${playlistId}`;
        await apiPatch(url, options);

        setPlaylistGroups(newList);

        setIsDeleting(false);
        setModalOpen(false);
        setIsGroupDeletion(false);
    };

    const onDeleteHandler = id => {
        setModalOpen(true);
        setIsGroupDeletion(true);
        setPlaylistGroupId(id);
    };

    const generatePlaylistActionButtons = (ele, index, itemsLength) => [
        {
            icon: 'remove',
            onClick: () => onDeleteHandler(ele[RESPONSE.ID])
        }
    ];

    return (
        <>
            <div
                className='b-device-playlist_group'
            >
                    <h3 className="playlists-header">
                    {t('playlist_group')}
                    </h3>
                    {playlistGroups && isEmpty(playlistGroups) && <NoPlaylistsText />}
                    {playlistGroups && playlistGroups.map((group, index) => (
                        <PlaylistGroupCard
                            name={`playlist-group-card-${index + 1}`}
                            playlistGroup={group}
                            buttons={generatePlaylistActionButtons(
                                group, index, playlistGroups.length
                            )}
                        />
                    ))}
            </div>
            <DeleteConfirmationModal
                show={isModalOpen && isGroupDeletion}
                onClose={onCancelDeletion}
                onCancel={onCancelDeletion}
                onAction={() => deletePlaylistGroup(playlistGroupId)}
                localeAction={t('delete')}
                localeCancel={t('cancel')}
                isLoading={isDeleting}
            >
                <h4>{t('delete_playlist_group_device')}</h4>
            </DeleteConfirmationModal>
        </>
    );
};

export default DevicePlaylistGroup;
